module.exports = __webpack_public_path__ + "img/join@0.5x.43b90814.jpg";